import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 720,
		width: '100%',
	},
	title: {
		color: THEME.colors.text.main,
		fontSize: 16,
		fontWeight: 600,
		margin: 0,
		marginBottom: SPACE[16],
	},
	stage: {
		// The cropper positions its overlay absolutely against this box, and sizes the image to fill it.
		backgroundColor: THEME.colors.chart.topHatBlack,
		borderRadius: THEME.common.borderRadius,
		height: 400,
		overflow: 'hidden',
		position: 'relative',
		width: '100%',
	},
	presetRow: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[4],
		marginTop: SPACE[16],
	},
	preset: {
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		minWidth: 84,
		padding: `${SPACE[8]}px ${SPACE[16]}px`,
	},
	presetActive: {
		backgroundColor: THEME.colors.primary.light,
		borderColor: THEME.colors.primary.main,
	},
	presetLabel: {
		color: THEME.colors.text.main,
		fontSize: 13,
		fontWeight: 600,
	},
	controls: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[16],
		marginTop: SPACE[16],
	},
	zoomLabel: {
		color: THEME.colors.text.light,
		fontSize: 13,
		fontWeight: 500,
		whiteSpace: 'nowrap',
	},
	zoomSlider: {
		appearance: 'none',
		backgroundColor: THEME.colors.background.dark,
		borderRadius: THEME.common.borderRadius,
		cursor: 'pointer',
		flex: 1,
		height: 4,
		outline: 'none',
		'::-webkit-slider-thumb': {
			appearance: 'none',
			backgroundColor: THEME.colors.primary.main,
			borderRadius: '50%',
			cursor: 'pointer',
			height: 16,
			width: 16,
		},
		'::-moz-range-thumb': {
			backgroundColor: THEME.colors.primary.main,
			border: 'none',
			borderRadius: '50%',
			cursor: 'pointer',
			height: 16,
			width: 16,
		},
	},
	error: {
		color: THEME.colors.danger.dark,
		fontSize: 12,
		marginBottom: 0,
		marginTop: SPACE[8],
	},
	actions: {
		display: 'flex',
		gap: SPACE[8],
		justifyContent: 'flex-end',
		marginTop: SPACE[16],
	},
});
